import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchListaContribuintes } from '../api/ListaContribuintesApi';
import type { ContribuinteDetalhado } from '../types';

export function useListaContribuintes(
  snac?: string | null,
  options?: Omit<UseQueryOptions<ContribuinteDetalhado[], Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const queryKey = snac ? ['contribuintes', cnpjGestor, snac] : ['contribuintes', cnpjGestor];

  const query = useQuery<ContribuinteDetalhado[], Error>({
    queryKey,
    queryFn: async () => {
      const response = await fetchListaContribuintes(snac);
      return response;
    },
    staleTime: 10 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && !!cnpjGestor,
  });

  useEffect(() => {
    if (query.error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar contribuintes',
        description: 'Não foi possível carregar a lista de contribuintes. Tente novamente.',
      });
    }
  }, [query.error, toast]);

  return query;
}
